import {
  base_colorAction,
  base_colorContentBorder,
  base_colorRaisedSurface,
  base_colorSurfaceSecondary,
  cta_alertButtonBorder,
  cta_buttonSecondaryBackground,
  cta_buttonSecondaryBackgroundHover,
  cta_buttonSecondaryBorder,
  tag_colorTagSevereText,
  text_colorTextPrimary,
  text_colorTextSecondary,
  text_colorTextSuccess,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;

  .ReceiptEvidencePanel--scroll-content {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: ${spacing(5)};
    min-height: 0;
    padding: ${spacing(6)} ${spacing(10)};
    overflow-y: auto;
  }

  .ReceiptEvidencePanel--action-bar,
  .ReceiptEvidencePanel--action-group,
  .ReceiptEvidencePanel--metadata,
  .ReceiptEvidencePanel--provenance,
  .ReceiptEvidencePanel--verified,
  .ReceiptEvidencePanel--agent-provenance,
  .ReceiptEvidencePanel--review-outcome,
  .ReceiptEvidencePanel--review-outcome-label,
  .ReceiptEvidencePanel--review-actions,
  .ReceiptEvidencePanel--unavailable {
    display: flex;
    align-items: center;
  }

  .ReceiptEvidencePanel--action-bar {
    flex: 0 0 auto;
    justify-content: space-between;
  }

  .ReceiptEvidencePanel--action-group {
    gap: ${spacing(1)};
  }

  .ReceiptEvidencePanel--icon-button {
    display: inline-flex;
    box-sizing: border-box;
    flex: 0 0 ${spacing(8)};
    align-items: center;
    justify-content: center;
    width: ${spacing(8)};
    height: ${spacing(8)};
    padding: ${spacing(2)};
    color: ${text_colorTextPrimary};
    background: ${cta_buttonSecondaryBackground};
    border: 1px solid ${cta_buttonSecondaryBorder};
    border-radius: ${cornerRadius};
    cursor: pointer;
    line-height: 0;
    text-decoration: none;
    transition: background-color 150ms ease-in-out;

    &:hover:not(:disabled) {
      background: ${cta_buttonSecondaryBackgroundHover};
    }

    &:focus-visible {
      outline: 2px solid ${base_colorAction};
      outline-offset: 2px;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }

  .ReceiptEvidencePanel--action-icon {
    position: relative;
    display: block;
    flex: 0 0 ${spacing(4)};
    width: ${spacing(4)};
    height: ${spacing(4)};

    img {
      position: absolute;
      display: block;
      max-width: none;
    }
  }

  .ReceiptEvidencePanel--action-icon-external-link img {
    top: 2.33px;
    left: 2.17px;
    width: 11.8564px;
    height: 11.5049px;
  }

  .ReceiptEvidencePanel--action-icon-delete img {
    top: 2.83px;
    left: 3.17px;
    width: 9.66602px;
    height: 10.667px;
  }

  .ReceiptEvidencePanel--action-icon-download svg {
    display: block;
    width: ${spacing(4)};
    height: ${spacing(4)};
  }

  .ReceiptEvidencePanel--action-icon-plus img {
    top: 3.83px;
    left: 3.83px;
    width: 9px;
    height: 9px;
  }

  .ReceiptEvidencePanel--action-icon-collapse img {
    top: 3.83px;
    left: 7.83px;
    width: 1px;
    height: 9px;
    transform: rotate(90deg);
  }

  .ReceiptEvidencePanel--preview {
    flex: 1 1 0;
    min-height: 0;
    max-height: ${spacing(160)};
    overflow: auto;
    background: ${base_colorSurfaceSecondary};
    border: 1px solid ${base_colorContentBorder};
    border-radius: ${cornerRadius};

    &[data-zoomed='true'] {
      cursor: move;
      user-select: none;
    }

    &[data-panning='true'] {
      cursor: grabbing;
    }
  }

  .ReceiptEvidencePanel--preview-canvas {
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(100% * var(--receipt-evidence-zoom));
    height: calc(100% * var(--receipt-evidence-zoom));
    min-width: 100%;
    min-height: 100%;
  }

  .ReceiptEvidencePanel--preview-image,
  .ReceiptEvidencePanel--preview-document {
    border: 0;
  }

  .ReceiptEvidencePanel--preview-document {
    width: 100%;
    height: 100%;
  }

  .ReceiptEvidencePanel--preview-image {
    width: auto;
    max-width: 100%;
    height: auto;
    max-height: 100%;
    object-fit: contain;
    background: ${base_colorRaisedSurface};
  }

  .ReceiptEvidencePanel--unavailable {
    flex-direction: column;
    gap: ${spacing(2)};
    margin: ${spacing(6)};
    color: ${text_colorTextSecondary};
    font-family: ${font_family_weight_regular};
    ${font_sm}
    text-align: center;
  }

  .ReceiptEvidencePanel--divider {
    flex: 0 0 auto;
    width: 100%;
    height: 1px;
    background: ${base_colorContentBorder};
  }

  .ReceiptEvidencePanel--metadata {
    flex-wrap: wrap;
    gap: ${spacing(1)};
    color: ${text_colorTextSecondary};
    font-family: ${font_family_weight_regular};
    ${font_sm}
  }

  .ReceiptEvidencePanel--provenance,
  .ReceiptEvidencePanel--verified {
    gap: ${spacing(1)};
  }

  .ReceiptEvidencePanel--provenance img {
    width: ${spacing(4)};
    height: ${spacing(4)};
  }

  .ReceiptEvidencePanel--verified {
    color: ${text_colorTextSuccess};
  }

  .ReceiptEvidencePanel--review-details {
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    align-items: flex-start;
    gap: ${spacing(2)};
  }

  .ReceiptEvidencePanel--review-details > .ReceiptEvidencePanel--divider {
    margin-block: ${spacing(3)};
  }

  .ReceiptEvidencePanel--agent-provenance {
    gap: ${spacing(1)};
  }

  .ReceiptEvidencePanel--agent-avatar {
    flex: 0 0 ${spacing(6)};
    width: ${spacing(6)};
    height: ${spacing(6)};
  }

  .ReceiptEvidencePanel--agent-label,
  .ReceiptEvidencePanel--recovered-title {
    color: ${text_colorTextPrimary};
    font-family: ${font_family_weight_medium};
    ${font_sm}
  }

  .ReceiptEvidencePanel--agent-meta,
  .ReceiptEvidencePanel--review-description,
  .ReceiptEvidencePanel--review-outcome {
    color: ${text_colorTextSecondary};
    font-family: ${font_family_weight_regular};
    ${font_sm}
  }

  .ReceiptEvidencePanel--review-description {
    margin: 0;
  }

  .ReceiptEvidencePanel--review-outcome {
    gap: ${spacing(1)};
  }

  .ReceiptEvidencePanel--review-outcome-label {
    color: ${text_colorTextSecondary};
    font-family: ${font_family_weight_regular};
    gap: ${spacing(1)};
  }

  .ReceiptEvidencePanel--review-outcome-approve
    .ReceiptEvidencePanel--review-outcome-label
    > svg {
    color: ${text_colorTextSuccess};
  }

  .ReceiptEvidencePanel--review-outcome-reject
    .ReceiptEvidencePanel--review-outcome-label
    > svg {
    color: ${tag_colorTagSevereText};
  }

  .ReceiptEvidencePanel--review-footer {
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    gap: ${spacing(3)};
    padding: ${spacing(5)};
    background: ${base_colorRaisedSurface};
    box-shadow: 3px 0 10px 0 rgba(0, 0, 0, 0.1);
  }

  .ReceiptEvidencePanel--review-actions {
    gap: ${spacing(4)};
    justify-content: space-between;
  }

  .ReceiptEvidencePanel--match-button {
    color: ${text_colorTextSuccess};
    border-color: ${text_colorTextSuccess};
  }

  .ReceiptEvidencePanel--reject-button {
    border-color: ${cta_alertButtonBorder};
  }
`
